import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { commitAllAcceptedChangeMonitoring } from '@api/manageNetworkElementConfigurations';

import {
	INetworkElementConfigurationsFilterAction,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_COMMIT_ALL_ACCEPTED_CHANGE_MONITORING } from '@constants/queryKeys';

interface IUseMutateChangeMonitoringCommitAllAcceptedReturned {
	isLoadingCommitAllAcceptedChangeMonitoring: boolean;
	commitAllAcceptedChanges: UseMutateAsyncFunction<any, any, INetworkElementConfigurationsFilterAction, any>;
}

const useMutateChangeMonitoringCommitAllAccepted = (
	onSuccess?: () => void,
): IUseMutateChangeMonitoringCommitAllAcceptedReturned => {
	const {
		isLoading,
		mutateAsync,
	} = useMutation<INetworkElementConfigurationsFilterAction>({
		mutationKey: [NETWORK_ELEMENT_COMMIT_ALL_ACCEPTED_CHANGE_MONITORING],
		mutationFn: commitAllAcceptedChangeMonitoring,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess,
	});

	return {
		isLoadingCommitAllAcceptedChangeMonitoring: isLoading,
		commitAllAcceptedChanges: mutateAsync,
	};
};

export default useMutateChangeMonitoringCommitAllAccepted;
